import React from 'react';
import PropTypes from 'prop-types';
import styles from './AudioRecorder.less';

export const AudioPlaybackControls = ({ url }) => {
  return (
    <div className={styles.audioPlaybackControls}>
      <audio controls="controls" src={url} controlsList="nodownload" />
    </div>
  );
};

AudioPlaybackControls.propTypes = {
  url: PropTypes.string.isRequired,
};
